import React, {useState} from "react";
import UserPageComponents from "../user-page/user-page-components/UserPageComponents";

const UserPage = () => {
    return(
        <div class="App">
            <UserPageComponents />
        </div>
    );
}

export default UserPage;